export default function navigation() {
	const siteNavigation = document.getElementById('nawigacja');

	if (!siteNavigation) {
		console.warn('No site navigation found.');

		return;
	}

	const navList = siteNavigation.getElementsByTagName('ul')[0];

	if (typeof navList === 'undefined') {
		return;
	}
	const links = navList.getElementsByTagName('a');

	const navToggle = document.createElement('button');

	navToggle.setAttribute('type', 'button');
	navToggle.setAttribute('aria-controls', 'nawigacja');
	navToggle.setAttribute('aria-label', 'Otwórz menu');
	navToggle.classList.add('nav__toggle');
	navToggle.appendChild(document.createElement('span'));
	siteNavigation.prepend(navToggle);

	const toggleMenu = function() {
		siteNavigation.classList.toggle('is-visible');
		navList.classList.toggle('is-visible');
		navToggle.classList.toggle('is-expanded');
		document.body.classList.toggle('has-nav-expanded');

		if (navToggle.getAttribute('aria-expanded') === 'true') {
			navToggle.setAttribute('aria-expanded', 'false');
		} else {
			navToggle.setAttribute('aria-expanded', 'true');
		}
	};

	navToggle.addEventListener('click', () => {
		toggleMenu();
	});

	for (let i = 0; i < links.length; i++) {
		links[i].addEventListener('click', () => {
			siteNavigation.classList.remove('is-visible');
			navList.classList.remove('is-visible');
			navToggle.classList.remove('is-expanded');
			document.body.classList.remove('has-nav-expanded');
			navToggle.setAttribute('aria-expanded', 'false');
		});
	}

	const subToggles = document.querySelectorAll('.nav__parent .nav__sub-toggle');
	subToggles.forEach(subToggle => {
		subToggle.addEventListener('click', (event) => {
			event.stopPropagation();
			const subListWrapper = subToggle.closest('.nav__parent').querySelector('.nav__sub-list-wrapper');

			document.querySelectorAll('.nav__sub-list-wrapper').forEach(wrapper => {
				if (wrapper !== subListWrapper) {
					wrapper.classList.remove('is-visible');
				}
			});

			subListWrapper.classList.toggle('is-visible');
		});
	});
}
